module.exports = __webpack_public_path__ + "img/LikeIconFilled.14aad470.svg";